import React from "react";
import { Card, CardContent, Box, Typography, Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import AutoMode from "./AutoModeConfig";
// import deviceStore from "../../../stores/DeviceStore";

const TotalDevicesCard = ({
  totalCount,
  pendingCount,
  renderHeader,
  loading,
  mode,
  setMode,
  handleStartCountdown,
}) => {
  return (
    <Card sx={cardStyle}>
      <CardContent sx={{ p: 1, "&:last-child": { pb: 1 }, height: "100%" }}>
        {renderHeader(`Total Devices: ${totalCount}`, "total", mode)}

        {mode === "auto" ? (
          <AutoMode
            metricType="total"
            setMode={setMode}
            onApply={(metricType, duration) => {
              if (metricType === "total") {
                // deviceStore.setFetchDuration(duration);
                // deviceStore.loadDevices();
              }
              handleStartCountdown(
                metricType,
                parseInt(duration.replace("m", ""))
              );
            }}
          />
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexGrow: 1,
              mt: 5,
              mb: 2,
            }}
          >
            {loading ? (
              <>
                <Box sx={registeredBoxStyle}>
                  <Skeleton variant="text" width="60%" sx={{ mx: "auto" }} />
                  <Skeleton
                    variant="text"
                    width="80%"
                    sx={{ mx: "auto", mt: 1 }}
                  />
                </Box>

                <Box sx={pendingBoxStyle}>
                  <Skeleton variant="text" width="60%" sx={{ mx: "auto" }} />
                  <Skeleton
                    variant="text"
                    width="80%"
                    sx={{ mx: "auto", mt: 1 }}
                  />
                </Box>
              </>
            ) : (
              <>
                <Box sx={registeredBoxStyle}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#22C55E",
                      fontWeight: 600,
                      fontSize: "0.75rem",
                    }}
                  >
                    Registered
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      color: "#000",
                      mt: 0.5,
                      fontSize: "1.25rem",
                    }}
                  >
                    {totalCount - pendingCount}
                  </Typography>
                </Box>

                <Box sx={pendingBoxStyle}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#FF9900",
                      fontWeight: 600,
                      fontSize: "0.75rem",
                    }}
                  >
                    Pending
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      color: "#000",
                      mt: 0.5,
                      fontSize: "1.25rem",
                    }}
                  >
                    {pendingCount}
                  </Typography>
                </Box>
              </>
            )}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

const cardStyle = {
  borderRadius: 2,
  boxShadow: 1,
  backgroundColor: "#F9FAFB",
  width: "100%",
  minWidth: 0,
  maxWidth: 320,
  p: 1,
  height: 260,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
};

const registeredBoxStyle = {
  backgroundColor: "#E6F4EA",
  borderRadius: 1,
  py: 1.5,
  px: 2.5,
  textAlign: "center",
  width: 120,
  mr: 1,
};

const pendingBoxStyle = {
  backgroundColor: "#FFE8CC",
  borderRadius: 1,
  py: 1.5,
  px: 2.5,
  textAlign: "center",
  width: 120,
  ml: 1,
};

TotalDevicesCard.propTypes = {
  totalCount: PropTypes.number.isRequired,
  pendingCount: PropTypes.number.isRequired,
  renderHeader: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  mode: PropTypes.string.isRequired,
  setMode: PropTypes.func.isRequired,
  handleStartCountdown: PropTypes.func.isRequired,
};

export default TotalDevicesCard;
